export default __webpack_public_path__ + "static/media/search.5218b4fa.svg";